import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import api from "../utils/api";

function Prodtected() {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const res = await api.get("protected", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data) {
          navigate("/");
        }
      } catch (err) {
        console.error("Verification failed:", err.response?.data);
        localStorage.removeItem("token");
        navigate("/login");
      }
    };

    verifyToken();
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Doğrulama Yapılıyor...</h1>
        <p>Lütfen bekleyin, giriş bilgileriniz kontrol ediliyor.</p>
      </div>
    </div>
  );
}

export default Prodtected;
